import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from './redux/store'
import { Slide, ToastContainer } from 'react-toastify';

import lib from './biz/lib'

// components
import RightDrawerPage from './components/RightNavDrawer'

// redux 
import { updateUserSlice } from './redux/features/userSlice'

// biz
import userRoleBiz from './biz/userRoleBiz'
import sharedBiz from './biz/sharedBiz'
import announcementBiz from './biz/announcementBiz'
import AnnouncementModal from './components/AnnouncementModal'
import userBiz from './biz/userBiz'

const App = () => {
  const userSlice = useSelector((state: RootState) => state.user)
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)

  useEffect(() => {
    const handleStorageChange = (event: any) => {
      if (event.key === 'logoutFlag') {
        dispatch({ type: 'USER_LOGOUT' })
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      // Clean up the event listener when the component is unmounted
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch])

  // const logoutAgent = () => {
  //   dispatch({ type: 'USER_LOGOUT' })
  //   //@ts-ignore
  //   window.location = '/'
  // }

  //check version
  const checkVersion = async () => {
    const excludeCheck = ['local', 'sit'].includes(process.env.REACT_APP_QC_MODE || '');
    const currentVersion = process.env.REACT_APP_VERSION
    const latestVersion = await sharedBiz.getCurrentVersion()
    // lib.log("currentVersion: " + currentVersion)
    // lib.log("latestVersion : " + latestVersion.iroomz)
    if (!excludeCheck && latestVersion.iroomz !== currentVersion) {
      lib.log("window.reload(true)")
      dispatch({ type: 'USER_LOGOUT' });
      window.location.reload()
    }
  }

  //check user access
  const checkUserAccess = async () => {
    let userData = {}
    
    if (Boolean(userSlice?.profile?._id) === true) {
      const newAccess = await userRoleBiz.getById({ _id: userSlice?.profile?._id })

      if (newAccess) {
        if (!userSlice.profile.updated || userSlice.profile.updated < newAccess.updated) {
          const newData = await userBiz.getById({ _id: userSlice._id })

          userData = {
            ...newData,
            profile: {
              ...userSlice?.profile,
              modules: newAccess.modules,
              updated: newAccess.updated
            }
          }
          dispatch(updateUserSlice(userData))
        }
      }
    }
  }

  //get unread announcement count
  const getUnreadAnnouncement = async () => {
    const userId = userSlice?._id
    if (userId) {
      const unread = await announcementBiz.getUnreadAnnouncementById({ _id: userId })

      if (unread && unread.length > 0) {
        let userData = {
          ...userSlice,
          unread: unread
        }
        dispatch(updateUserSlice(userData))
        setModal(true)
      }
    }
  }

  // Refresh Page
  useEffect(() => {
    if (!userSlice?._id) return

    const initUser = async () => {
      const user = await userBiz.getById({ _id: userSlice?._id })
      const access = await userRoleBiz.getById({ _id: userSlice?.profile?._id })

      const userData = {
        ...user,
        profile: {
          ...userSlice?.profile,
          modules: access.modules,
          updated: access.updated
        }
      }

      dispatch(updateUserSlice(userData))
    }

    initUser()
  }, [])


  //On Focus 
  useEffect(() => {
    const onFocus = () => {
      checkVersion()
      checkUserAccess()
      getUnreadAnnouncement()
    }
    
    window.addEventListener('focus', onFocus);

    return () => {
      window.removeEventListener('focus', onFocus);
    }
  }, [userSlice])

  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <ToastContainer autoClose={2000} draggable={false} transition={Slide} />
            <RightDrawerPage />
            <Outlet />
            <MasterInit />
            {userSlice.unread && <AnnouncementModal
              modal={modal}
              setModal={setModal}
              announcements={userSlice.unread}
            />}
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </>
  )
}

export { App }
